<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <h1 class="main-heading">{{ 'rpe.vista-registro-actividad.title' | translate }}</h1>
        </div>
    </div>
    <div class="row justify-content-center" [ngClass]="routeAnimationsElements">
        <div class="col-md-8">
            <mat-card>
                <mat-horizontal-stepper labelPosition="bottom" #stepper>
                    <mat-step label="Almacenamiento" *ngIf="verStep(1)">
                        <rpe-registro-actividad-almacenamiento-tabs [formInput]="almacenamientoTabsData"
                            (formValueChanges)="formValueChanges($event)"
                            (formStatusChanges)="formStatusChanges($event)">
                        </rpe-registro-actividad-almacenamiento-tabs>
                    </mat-step>
                    <mat-step label="Criadero Registrante" *ngIf="verStep(3)">
                        <ng-template matStepContent>
                            <rpe-registro-actividad-ge-form [formInput]="gEFITA.get(3)">
                            </rpe-registro-actividad-ge-form>
                        </ng-template>
                    </mat-step>
                    <mat-step label="Experimentacion" *ngIf="verStep(4)">
                        <ng-template matStepContent>
                            <rpe-registro-actividad-ge-form [formInput]="gEFITA.get(4)">
                            </rpe-registro-actividad-ge-form>
                        </ng-template>
                    </mat-step>
                    <mat-step label="Exportacion" *ngIf="verStep(5)">
                        <ng-template matStepContent>
                            <rpe-registro-actividad-ge-form [formInput]="gEFITA.get(5)">
                            </rpe-registro-actividad-ge-form>
                        </ng-template>
                    </mat-step>
                    <mat-step label="Importacion" *ngIf="verStep(6)">
                        <ng-template matStepContent>
                            <rpe-registro-actividad-ge-form [formInput]="gEFITA.get(6)">
                            </rpe-registro-actividad-ge-form>
                        </ng-template>
                    </mat-step>
                    <mat-step label="Laboratorio" *ngIf="verStep(7)">
                        <div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">
                            <rpe-registro-actividad-laboratorio-tabs-form [formInput]="laboratorioFormInput"
                                (formValueChanges)="formValueChanges($event)"
                                (formStatusChanges)="formStatusChanges($event)">
                            </rpe-registro-actividad-laboratorio-tabs-form>
                        </div>
                    </mat-step>
                    <mat-step label="Procesamiento" *ngIf="verStep(8)">
                        <div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">
                        </div>
                    </mat-step>
                    <mat-step label="Produccion" *ngIf="verStep(9)">
                        <ng-template matStepContent>
                            <rpe-registro-actividad-ge-form [formInput]="gEFITA.get(9)">
                            </rpe-registro-actividad-ge-form>
                        </ng-template>
                    </mat-step>
                    <mat-step label="Comercialización" *ngIf="verStep(2)">
                        <ng-template matStepContent>
                            <div class="row buttons d-flex justify-content-between pad"
                                [ngClass]="routeAnimationsElements">
                                <rpe-registro-actividad-comercializacion-form [formInput]="gEFITA.get(2)">
                                </rpe-registro-actividad-comercializacion-form>
                            </div>
                        </ng-template>
                    </mat-step>
                    <mat-step label="Acreditación" *ngIf="verStep(10)">
                        <div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">
                            <rpe-registro-actividad-acreditacion-form [formInput]="regActAcreFormInput"
                                (formValueChanges)="formValueChanges($event)"
                                (formStatusChanges)="formStatusChanges($event)">
                            </rpe-registro-actividad-acreditacion-form>
                        </div>
                    </mat-step>


                    <mat-step label="Finalizar">
                        <div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">
                            <button (click)="onCancel()" mat-raised-button matStepperPrevious>
                                {{ 'rpe.vista-usuario.volver' | translate }}
                            </button>
                            <button mat-raised-button (click)="onSiguiente()" color="primary" matStepperNext>
                                {{ 'rpe.vista-usuario.guardar-y-continuar' | translate }}
                            </button>
                        </div>
                    </mat-step>
                </mat-horizontal-stepper>
            </mat-card>
        </div>
    </div>
</div>